(function() {
	const STORAGE_KEY = "ldc_cta_bar_closed";
	const LEGACY_COOKIE = "ldc_cta_bar_closed";
	const DISMISS_CLASS = "ctabar-dismissed-mobile";

	function isMobile() {
		return window.matchMedia("(max-width: 575px)").matches;
	}

	function isDismissedThisSession() {
		try {
			return sessionStorage.getItem(STORAGE_KEY) === "1";
		} catch (e) {
			return false;
		}
	}

	function setDismissedThisSession() {
		try {
			sessionStorage.setItem(STORAGE_KEY, "1");
		} catch (e) {
			// Storage blocked — class still hides bar for this page.
		}
	}

	function clearLegacyCookie() {
		document.cookie = LEGACY_COOKIE + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax";
	}

	function applyMobileDismissState() {
		if (isDismissedThisSession() && isMobile()) {
			document.documentElement.classList.add(DISMISS_CLASS);
		}
	}

	function dismissOnMobile() {
		if (!isMobile()) {
			return;
		}
		setDismissedThisSession();
		document.documentElement.classList.add(DISMISS_CLASS);
	}

	function init() {
		clearLegacyCookie();
		applyMobileDismissState();

		const closeButton = document.querySelector(".ctabar__close");
		if (closeButton) {
			closeButton.addEventListener("click", function(e) {
				e.preventDefault();
				dismissOnMobile();
			});
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
